import * as Sentry from '@sentry/nextjs'

const isLocalhost =
  typeof window !== 'undefined' && window.location.hostname === 'localhost'
const isProd = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'

if (isProd && !isLocalhost) {
  Sentry.init({
    dsn: 'https://af2e4ab7a38bbc91b4e6222806a76f99@o4507510040559616.ingest.de.sentry.io/4507510089646160',
    integrations: [
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.httpClientIntegration({ failedRequestStatusCodes: [[400, 599]] }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.9,
    environment: 'production',
  })
}
